var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastSafe = function SvgFastSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M5.25 28c0-12.84 10.41-23.25 23.25-23.25S51.75 15.16 51.75 28 41.34 51.25 28.5 51.25 5.25 40.84 5.25 28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#269636",
    d: "M44.407 12.329q.587 0 1.197-.019l1.444-.043V31.09c0 4.928-1.87 12.116-18.042 17.615l-.503.172-.504-.172C11.827 43.205 9.957 36.018 9.957 31.09V12.267l1.444.043c11.24.337 16.028-6.444 16.073-6.488l1.03-.99 1.029.99c.038.036 4.576 6.507 14.874 6.507"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.81 34.957-9.9-7.887 2.63-1.917 5.264 3.492s7.268-6.76 14.286-9.915l1.002 1.015s-8.77 6.535-13.282 15.212"
  })));
};
export default SvgFastSafe;